<template>
  <v-dialog scrollable fullscreen v-model="config.status.active" class="preview">
    <v-card>
      <v-toolbar color="blue darken-2">
        <v-toolbar-title class="white--text">{{ printTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container grid-list-md fill-height>
        <p v-if="!isErrorEmpty" class="text-xs-left" style="width:100%;height:100%;">
          <span class="body-2">{{ printViewerError }}</span>
        </p>
        <iframe :src="printPreviewURL" v-else-if="!isUrlEmpty" style="display:block;border:none;width:100%;height:100%;" />
        <iframe :srcdoc="printPreviewDoc" v-else-if="!isDocEmpty" style="display:block;border:none;width:100%;height:100%;" />
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
          color="secondary"
          @click="close"
        >閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'preview-modal',
  props: [
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false,
          downloading: false
        }
      },
      meta: {
      },
      form: {
      },
      store: {
        item: null,
        url: '',
        doc: ''
      },
      error: {
        preview: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this.store, 'url', '')
      this.$set(this.store, 'doc', '')
      this.$set(this.error, 'preview', '')
      this.get()
    },
    open: function (item) {
      if (item) {
        this.$set(this.store, 'item', item)
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.init()
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('closed')
    },
    get: function () {
      if (this.store.item && this.store.item.id) {
        const urls = {
          default: `${this.$url.api}box/preview/${this.store.item.id}`,
          eml: `${this.$url.api}box/preview/eml/${this.store.item.id}`
        }
        this.$set(this.config.status, 'loading', true)
        const extension = !this.store.item.extension ? this.store.item.name.split('.').pop() : this.store.item.extension
        const url = urls[extension] || urls.default
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, {
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.error, 'preview', '')
              if (extension === 'eml') {
                this.$set(this.store, 'doc', res.data.data.html || res.data.data.text.replace(/\r?\n/g, '<br />'))
                this.$set(this.store, 'url', '')
              } else {
                this.$set(this.store, 'doc', '')
                this.$set(this.store, 'url', res.data.data)
              }
            } else if (
              res.data &&
              res.data.data &&
              res.data.data.response &&
              res.data.data.response.body &&
              res.data.data.response.body.code
            ) {
              let code = res.data.data.response.body.code
              let err = this.$error.box.file.open[code] ? this.$error.box.file.open[code] : ''
              this.$set(this.error, 'preview', err)
              this.$set(this.store, 'doc', '')
              this.$set(this.store, 'url', '')
            }
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    download: function () {
      if (this.store.item && this.store.item.id) {
        this.$set(this.config.status, 'downloading', true)
        let uid = this.$store.getters['author/get']('tokens').box
        let url = this.$url.api + 'box/download/' + this.store.item.id
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, {
            uid: uid
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'downloading', false)
            if (res.data && res.data.success) {
              window.location.href = res.data.data
            } else if (
              res.data &&
              res.data.data &&
              res.data.data.response &&
              res.data.data.response.body &&
              res.data.data.response.body.code
            ) {
              let code = res.data.data.response.body.code
              let err = this.$error.box.file.open[code] ? this.$error.box.file.open[code] : ''
              this.$set(this.error, 'preview', err)
            }
          })
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isDownloading () {
      return this.config.status.downloading
    },
    isSearching () {
      return this.config.status.searching
    },
    isUrlEmpty () {
      return !!(this.store.url === '')
    },
    isDocEmpty () {
      return !!(this.store.doc === '')
    },
    isErrorEmpty () {
      return !!(this.error.preview === '')
    },
    printTitle () {
      return (
        this.store.item &&
        this.store.item.name
      ) ? this.store.item.name : '無名のファイル'
    },
    printPreviewURL () {
      return this.store.url
    },
    printPreviewDoc () {
      return this.store.doc
    },
    printViewerError () {
      return this.error.preview
    }
  }
}
</script>

<style lang="scss">
.preview {
  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
